import React from "react";
import validationRules from "../../validations/contactusvalidationrules.json";
import "../../styles/textinput.css";

const PhoneInput = ({ name, value, onChange, error, setError }) => {
  const handleCodeChange = (e) => {
    const newCode = e.target.value.replace(/\D/g, "");
    const newPhone = value.split("-")[1] || "";
    onChange({
      target: {
        name,
        value: `+${newCode}-${newPhone}`,
      },
    });
  };

  const handleNumberChange = (e) => {
    const code = value.split("-")[0] || "+";
    const newNumber = e.target.value.replace(/\D/g, "");
    onChange({
      target: {
        name,
        value: `${code}-${newNumber}`,
      },
    });
  };

  const handleBlur = () => {
    const [countryCode, phoneNumber] = value.split("-");
    const cleanCode = countryCode?.replace(/\D/g, "") || "";
    const cleanPhone = phoneNumber?.replace(/\D/g, "") || "";

    if (cleanCode.length !== validationRules.phone.countryCodeLength) {
      setError(
        `Country code must be ${validationRules.phone.countryCodeLength} digits`
      );
    } else if (cleanPhone.length !== validationRules.phone.numberLength) {
      setError(
        `Phone number must be ${validationRules.phone.numberLength} digits`
      );
    } else {
      setError("");
    }
  };

  return (
    <div className="form-group">
      <div className="phone-inputs">
        <input
          type="text"
          style={{ width: "40%" }}
          placeholder="Country Code"
          value={value.split("-")[0].replace("+", "")}
          onChange={handleCodeChange}
          onBlur={handleBlur}
          maxLength={validationRules.phone.countryCodeLength}
        />
        <input
          type="text"
          style={{ width: "60%" }}
          placeholder="Phone Number"
          value={value.split("-")[1] || ""}
          onChange={handleNumberChange}
          onBlur={handleBlur}
          maxLength={validationRules.phone.numberLength}
        />
      </div>
      {error && (
        <span className="error" style={{ marginTop: "4px" }}>
          {error}
        </span>
      )}
    </div>
  );
};

export default PhoneInput;
